import { IconProps } from './types';

export const CloseIconCircle = ({
  size = 20,
  stroke = 'white',
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="256"
        cy="256"
        r="256"
        fill="currentColor"
      />
      <g transform="translate(256, 256)">
        <g transform="scale(0.65)">
          <path
            d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
            transform="translate(-192, -256)"
            fill={stroke}
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};
